<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      title="One Off Fee Info."
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-row class="mt-3">
          <v-col cols="12">
            <SimplePageHeader title="Assignment"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Consultant"
              v-bind:value="userName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Client"
              v-bind:value="clientName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <SimplePageHeader title="Fee"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12" sm="8">
            <v-text-field
              label="Description"
              v-model="oneOffFeeInfo.description"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Date"
              v-model="dateValue"
              readonly
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <FormattedNumberField
              label="Pay Amount"
              :value="oneOffFeeInfo.payAmount"
              :readonly="true"
              prepend-inner-icon="attach_money"
            ></FormattedNumberField>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <FormattedNumberField
              label="Bill Amount"
              :value="oneOffFeeInfo.billAmount"
              :readonly="true"
              prepend-inner-icon="attach_money"
            ></FormattedNumberField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="oneOffFeeInfo.notes"
              label="Notes"
              readonly
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-12">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Close
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import SimplePageHeader from '@/components/pageComponents/SimplePageHeader'
import { formatDate } from '@/lib/display'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    DynamicModal,
    SimplePageHeader,
    FormattedNumberField
  },
  props: [
    'userName',
    'clientName',
    'oneOffFeeInfo'
  ],
  data () {
    return {
      showModalProp: false
    }
  },
  computed: {
    dateValue: {
      get () {
        return this.formatDate(this.oneOffFeeInfo.date)
      }
    }
  },
  methods: {
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.$emit('closeModal')
    },
    formatDate
  }
}
</script>
